export default "__VITE_ASSET__BlE13xZ$__"